/** Group all incoming and outgoing relationships for one entity. */
export const PLANT_ENTITY_CONNECTIONS_CYPHER = `
  MATCH (n {id: $id})-[r]-(peer)
  WITH type(r) AS type,
       CASE WHEN startNode(r) = n THEN 'out' ELSE 'in' END AS direction,
       peer,
       properties(r) AS props
  ORDER BY toLower(coalesce(peer.name, peer.id))
  WITH type, direction, count(*) AS total,
       collect({peer: peer, peerLabels: labels(peer), props: props}) AS rows
  RETURN type, direction, total, rows
  ORDER BY type, direction
`
